import customSelect from 'custom-select';

const mySelects = customSelect(".select");
